import getLocal from 'eco-design-reliance/getLocal';
import EcoLink from 'eco-design/base/eco-link';
import HeaderIconUser from '../IconUser';

// 已经登录
export default function HeaderUserLogin({ className }: any) {
    const { locale = 'us' } = getLocal();
    return (
        <EcoLink
            href={`/${locale}/my-overview`}
            className={`ef-header-v2-bar-item ef-header-bar-user ef-header-bar-user-UserLogin GtmModuleData-btn-common ${className}`}
            aria-label={'user'}
            data-btn-id="user"
            dataLayer={{
                event: 'uaEvent',
                event_name: 'top_function',
                button_name: 'Brand_My Account_Logged in',
                __btn_id1: `ef-header-user`,
                __btn_id2: `user`,
                __btn_type: 'common',
            }}
        >
            <HeaderIconUser />
        </EcoLink>
    );
}
